//*******************************************************************************************
//* WaMS Component Framework - app.input.js
//* Version 0.1
//* Author: Damian Koch
//* Component framework input helpers plugin
//* Requires jQuery, WaMS Component Framework
//*
//* This component adds some rich input features.  When this file is loaded, certain
//* fields/attributes will be looked for in forms on showEditMode complete.
//*******************************************************************************************

app.input = (function () {
    var myInput = {
        Init: function () {
            this.initInputComponents(document);
            //init page
            app.input.initClearForm();
            //init future components
            $(document).on('component-bind-edit-mode-complete', function (e, component) {
                if (component.page.isDebugMode) {
                    util.console.log('component-bind-edit-mode-complete triggered:', util.console.calloutContent(component.type));
                }
                app.input.initInputComponents(component.editComponent);
            });
        },
        initInputComponents: function (el) {
            app.input.initMasks(el);
            app.input.initTextEditor(el);
            app.input.initDatePicker(el);
            app.input.initSelectMany(el);
            app.input.initAutocomplete(el);
            app.input.initTextAreaWithLimit(el);
            app.input.initShowPassword(el);
        },
        initMasks: function (editComponent) {
            $('[data-component-input-type="Phone"]', editComponent).mask('(999)999-9999?, ext.9999999999');
            $('[data-component-input-type="date"]', editComponent).mask('99/99/9999');
            $('[data-component-input-type="monthyeardate"]', editComponent).mask('99/9999');
            $('[data-component-input-type="numeric"]', editComponent).mask('##########.##', { reverse: true });
            $('[data-component-input-type="currency"]', editComponent).mask('#,##0.00', { reverse: true });
        },
        initSelectMany: function (editComponent) {
            $('[data-role="select-many"]', editComponent).each(function () {
                var selectManyContext = this;

                app.input.listSelectedSelectMany($('fieldset', selectManyContext));

                //on change update selection list label
                $('input[type="checkbox"]', selectManyContext).on('change', function () { app.input.listSelectedSelectMany($('fieldset', selectManyContext)); });

                //filter event listener
                $(selectManyContext).on('keyup', '[data-role="select-many-filter"]', function () {
                    var value = $(this).val().toLowerCase();
                    const selMany = $(this).closest('[data-role="select-many"]');

                    selMany.find('.select-many-checkbox').each(function () {
                        if ($(this).find('label').text().toLowerCase().search(value) > -1) {
                            $(this).show();
                            //show group
                            $(this).closest('[data-role="select-many-group"]').show();
                        }
                        else {
                            $(this).hide();
                            if ($(this).closest('[data-role="select-many-group"]').find('.select-many-checkbox:visible').length === 0) {
                                //hide group
                                $(this).closest('[data-role="select-many-group"]').hide();
                            }
                        }
                    });

                    var selAll = selMany.find('[type="checkbox"][data-role~="selectall"]:visible');
                    var selAllChecked = true;

                    //loop through visible values, if any is false, then mark the box as not all selected
                    selMany.find('.select-many-checkbox input[type="checkbox"]:visible').each(function (ind, el) {
                        if ($(el).prop('checked') !== true) {
                            selAllChecked = false;
                            // returning false breaks from loop
                            return false;
                        }
                    });

                    selAll.prop('checked', selAllChecked);
                });

                util.console.log(editComponent);

                //custom dropdown filter event listener
                $(editComponent).on('change', 'select[data-role="filter-select-many"]', function () {
                    //var filterField = $(this).data("filter-field");
                    var filterTargetFieldset = $("#fst" + $(this).data("target"), selectManyContext);
                    //var selectedOption = $(this).val();

                    var allSelects = $('select[data-role="filter-select-many"][data-target="' + $(this).data("target") + '"]');

                    filterTargetFieldset.find(".select-many-checkbox").each(function () {
                        var showThis = true;
                        var curCheckbox = $(this).find("input");

                        allSelects.each(function (el) {
                            var selectedOption = $(this).val();
                            var filteredField = $(this).data("filter-field");
                            var filteredFieldValue = curCheckbox.data(filteredField);

                            showThis = showThis && (selectedOption == null || selectedOption === "" || filteredFieldValue == selectedOption);
                        });

                        if (showThis) {
                            $(this).show();
                        }
                        else {
                            $(this).hide();
                        }
                    });

                    var selAll = $('[type="checkbox"][data-role~="selectall"][name="' + $(this).data("target") + '"]:visible', selectManyContext);
                    var selAllChecked = true;
                    $('.select-many-checkbox input[type="checkbox"][name="' + $(this).data("target") + '"]:visible', selectManyContext).each(function (ind, el) {
                        if ($(el).prop('checked') != true) {
                            selAllChecked = false;
                            // returning false breaks from loop
                            return false;
                        }
                    });

                    selAll.prop('checked', selAllChecked);
                });
            });
        },
        listSelectedSelectMany: function (el) {
            var selectedCheckboxNames;
            var context = $(el).closest('[data-role="select-many"]');
            var fieldSet = $('fieldset', context);

            if ($('[type="checkbox"]:not(:checked)', fieldSet).length === 0) {
                selectedCheckboxNames = "All";
            }
            else {
                if ($('[type="checkbox"]:checked', fieldSet).length === 0) {
                    selectedCheckboxNames = "None";
                } else {
                    // NOTE: this is custom to WECAN! Be sure to check _WECANSelectMany.cshtml and _WECANSelectManyWithHeaders.cshtml before changing
                    selectedCheckboxNames = $('[type="checkbox"]:checked + span', fieldSet).map(function () {
                        return this.innerText;
                    }).get().join('; ');
                }
            }

            $('[data-role="selected-item-list"]', context).text(selectedCheckboxNames);
        },
        resetSelectManys: function (editComponent) {
            $('[data-role="select-many"]', editComponent).each(function () {
                //clear checkboxes
                $(".select-many-checkbox > input", this).prop("checked", false);
                //reset selected list
                app.input.listSelectedSelectMany($(this).find('fieldset'));
            });
        },
        initDatePicker: function (editComponent) {
            $('[data-component-role="startdate"]', editComponent).datepicker({ assumeNearbyYear: true }).on('changeDate', function (ev) {
                //When start date changes, check the end date
                //Find end date
                var endDateElement = $('#' + $(this).data('enddate-target'), $(this.form)).datepicker();

                if (ev.date.valueOf() > new Date(endDateElement.val()).getTime()) {
                    //If the end date is too early, set to know and give focus
                    var newDate = new Date(ev.date);
                    newDate.setDate(newDate.getDate() + 1);
                    endDateElement.datepicker('update', newDate);
                    $(this).datepicker('hide');
                    endDateElement[0].focus();
                }
            }).data('datepicker');

            $('[data-component-role="enddate"]', editComponent).datepicker({
                onRender: function (date) {
                    //get start date
                    var startDate = $('[data-enddate-target="' + this.element.attr('id') + '"').datepicker();
                    //Only allow
                    return date.valueOf() <= new Date(startDate.val()).getTime() ? 'disabled' : '';
                },
                assumeNearbyYear: true
            }).on('changeDate', function (ev) {
                $(this).datepicker('hide');
            }).data('datepicker');

            // options from: https://bootstrap-datepicker.readthedocs.io/en/stable/options.html
            $('[data-role~="datepicker"]', editComponent).datepicker({
                assumeNearbyYear: true,
                clearBtn: true,
                autoclose: true,
                templates: {
                    leftArrow: '<i class="fa fa-arrow-left"></i>',
                    rightArrow: '<i class="fa fa-arrow-right"></i>'
                }
            });
        },
        // https://www.tiny.cloud/docs-4x/general-configuration-guide/basic-setup/
        initTextEditor: function (editComponent) {
            $('[data-role~="richtext"]', editComponent).each(function (index) {
                tinymce.remove('#' + this.id);
                tinymce.init({
                    selector: '#' + this.id, // change this value according to your HTML
                    block_formats:
                        'Paragraph=p;Heading 1=h1;Heading 2=h2;Heading 3=h3;Heading 4=h4;Heading 5=h5;Heading 6=h6;Preformatted=pre',
                    themes: "modern",
                    plugins: "code lists link textcolor table",
                    mode: "textareas",
                    branding: false,
                    forced_root_block: "div",
                    menubar: false,
                    relative_urls: false,
                    toolbar: [
                        'bold italic superscript subscript | formatselect | numlist bullist | forecolor backcolor | alignleft aligncenter alignright | link | indent outdent | removeformat code'
                    ],
                    init_instance_callback: function (editor) {
                        editor.on('change', function (e) {
                            tinymce.triggerSave();
                            $('#' + e.target.id).valid();
                        });
                    }
                });

                //Hook hidden field into the validation
                //Tried setting this on the form on creation, on custom validators.... Would not bind correctly
                //This works the best out of kludge options
                var form = $(this.form);
                if (form != undefined) {
                    //create the validator
                    $.validator.unobtrusive.parse(form);
                    //set validator options
                    var validator = form.data('validator');
                    if (validator !== undefined) {
                        validator.settings.ignore =
                            ':hidden:not([data-role~="richtext"]),.mce-content-body';
                    }
                }
            });

            // limited version of the WYSIWYG editor
            $('[data-role~="richtextlimited"]', document).each(function (index) {
                // console.log("running richtextlimited");
                tinymce.remove('#' + this.id);
                tinymce.init({
                    selector: '#' + this.id, // change this value according to your HTML
                    block_formats:
                        'Paragraph=p;Heading 1=h1;Heading 2=h2;Heading 3=h3;Heading 4=h4;Heading 5=h5;Heading 6=h6;Preformatted=pre',
                    themes: "modern",
                    plugins: "code lists link textcolor table",
                    mode: "textareas",
                    branding: false,
                    menubar: false,
                    forced_root_block: "div",
                    toolbar: [
                        'bold italic | formatselect | numlist bullist | forecolor | alignleft aligncenter alignright | link | indent outdent | removeformat'
                    ],
                    init_instance_callback: function (editor) {
                        editor.on('change', function (e) {
                            tinymce.triggerSave();
                            $('#' + e.target.id).valid();
                        });
                    }
                });

                //Hook hidden field into the validation
                //Tried setting this on the form on creation, on custom validators.... Would not bind correctly
                //This works the best out of kludge options
                if (this.form !== null) {
                    var form = $(this.form);
                    //create the validator
                    $.validator.unobtrusive.parse(form);
                    //set validator options
                    var validator = form.data('validator');
                    if (validator !== undefined) {
                        validator.settings.ignore =
                            ':hidden:not([data-role~="richtextlimited"]),.mce-content-body';
                    }
                }
            });
        },
        initAutocomplete: function (editComponent) {
            $('[data-role~="autocomplete"]', editComponent).each(function () {
                var ac = $(this).AutoComplete();
            });
            app.Autocomplete.BindSetButtons(editComponent);
        },
        initTextAreaWithLimit: function (editComponent) {
            //setup the UI by adding HTML below element.
            $("textarea[data-val-length-max]", editComponent).each(function () {
                var uniqueId = app.Page.prototype.getGuid();
                $(this).data('char-count-target', uniqueId);
                $(this).after('<div id="' + uniqueId + '" class="text-limit-display">Character Count: 0</div>');
            });

            $("textarea[data-val-length-max]", editComponent).on("keyup", function (ev) {
                var $tar = $(ev.target);

                // grab data-charactercount-limit. Default to 500 if it is not defined
                var charactersAllowed = $tar.data("val-length-max") || 500;
                var characterCount = this.value.length;

                if (characterCount > charactersAllowed) {
                    $(this).val($(this).val().substring(0, charactersAllowed));
                    $('#' + $tar.data("char-count-target")).text("0 characters left");
                }
                else {
                    $('#' + $tar.data("char-count-target")).text((charactersAllowed - characterCount) + " characters left");
                }
            }).keyup();
        },
        initClearForm: function () {
            $("[data-role='clear-filter']").on('click', function () {
                app.input.clearForm($(this));
                app.input.initInputComponents();
            });
        },
        clearForm: function (sender) {
            // console.log($(sender).closest('form'));
            $(sender).closest('form').find(':input')
                .not(':button, :submit, :reset, :hidden, :checkbox, :radio')
                .val('')
                .prop('selected', false);

            $(sender).closest('form').find(':checkbox, :radio')
                .prop('checked', false);

            $(sender).closest('form').find('select')
                .prop('selectedIndex', 0);
        },
        initShowPassword: function (editComponent) {


            $("[data-role~='passwordview']", editComponent).each(function (i, el) {
                // insert the show password eye after the password input
                var shouldBeVisible = $(el).is(":visible");
                var showPasswordEye = "";
                if (shouldBeVisible) {
                    showPasswordEye =
                        "<div data-role='password-eye-prepend' class='input-group-append' aria-live='polite'>" +
                        "<button type='button' data-click='showPassword' aria-label='Password is hidden' class='input-group-text' style='cursor: pointer;' title='Show password' tabindex='0'>" +
                        "<i class='fa fa-eye'></i>" +
                        "</button>" +
                        "</div>";
                } else {
                    // set display none for the password eye if the parent isn't visible
                    showPasswordEye =
                        "<div style='display:none;' data-role='password-eye-prepend' class='input-group-append' aria-live='polite'>" +
                        "<button type='button' data-click='showPassword' aria-label='Password is hidden' class='input-group-text' style='cursor: pointer;' title='Show password' tabindex='0'>" +
                        "<i class='fa fa-eye'></i>" +
                        "</button>" +
                        "</div>";
                }
                //console.log($(el));
                //console.log(`Is visible: ${shouldBeVisible}`);
                //console.log("----------------------");

                $(showPasswordEye).insertAfter(this);
            });

            // create click event for password eyes
            $('[data-click~="showPassword"]', editComponent).each(function (j) {
                var passwordBox = $(this).parent().prev();
                $(this).on("click keyup",
                    function (e) {
                        var runFunc = false;
                        if (e.type === "keyup" || e.type === "click") {
                            if (e.type === "click" ||
                                e.key === " " ||
                                e.code === "Space" ||
                                e.keyCode === 32) {
                                runFunc = true;
                            }
                        }

                        if (runFunc) {
                            if (passwordBox.attr("type") === "password") {
                                $(this).attr("title", "Hide password");
                                $(this).attr("aria-label", "Password is shown");
                                $(this).children().first().removeClass("fa-eye").addClass("fa-eye-slash");
                                passwordBox.attr("type", "text");

                            } else {
                                $(this).attr("title", "Show password");
                                $(this).attr("aria-label", "Password is hidden");
                                $(this).children().first().removeClass("fa-eye-slash").addClass("fa-eye");
                                passwordBox.attr("type", "password");
                            }

                        }
                    });
            });
        }
    };

    return myInput;
}());

$(function () {
    app.input.Init();
});